import { CheckCircle2, ShieldCheck, Smartphone } from "lucide-react";

const FEATURES = [
  { icon: ShieldCheck, label: "Secure link validation" },
  { icon: Smartphone, label: "SMS code to the new number" },
  { icon: CheckCircle2, label: "Sign in again after completion" },
];

export default function Nd1ChangeMobileMarketing() {
  return (
    <aside className="nd1-auth-aside nd1-auth-aside--signin" aria-label="Mobile change guidance">
      <div className="nd1-auth-aside__copy">
        <p className="nd1-auth-card__eyebrow">Secure mobile update</p>
        <h1 className="nd1-auth-aside__title">
          <span className="nd1-ink">Change your mobile</span>
          <span className="nd1-ink-green">with verification.</span>
        </h1>
        <p className="nd1-auth-aside__lede">
          Mobile changes use a secure link and SMS confirmation to keep account ownership clear.
        </p>
      </div>
      <ul className="nd1-auth-aside__features">
        {FEATURES.map(({ icon: Icon, label }) => (
          <li key={label}>
            <Icon className="nd1-icon" aria-hidden="true" />
            <span>{label}</span>
          </li>
        ))}
      </ul>
    </aside>
  );
}
